import { connect } from 'react-redux';
import { closeMobileNav } from 'apps/topNavigation/actions/topNavigation';
import NavigationMenu from '../components/NavigationMenu';

const buildSectionLinks = (section, links) => section.childrenIds
  .map(childrenId => links[childrenId] || [])
  .reduce((acc, val) => acc.concat(val), []);

const getCurrentSections = (sections, links, navMenuLevel) =>
  sections[navMenuLevel].map(section => ({
    ...section,
    children: buildSectionLinks(section, links),
  }));

export default connect(
  state => ({
    opened: state.topNavigation.mobileNavigationOpened,
    // @TODO: This method always returns new arrays which causes component to rerender itself without good reason.
    sections: getCurrentSections(
      state.topNavigation.navMenuContents, state.topNavigation.links, state.topNavigation.navMenuLevel,
    ),
    navMenuLevel: state.topNavigation.navMenuLevel,
  }),
  {
    closeMobileNav,
  },
)(NavigationMenu);
